<template>
  <div>
    <list row-key="Id" ref="list" unit="用户" :page="page" :show-checkbox="true" :show-query="true"
      :get-data-func="getDataFunc" :query-params="params">
      <template slot="toolbar-right">
        <el-button type="success">导入</el-button>
        <el-button type="success" plain>导出</el-button>
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      // api: require("@/api/ba/equipmentFailure").default,
      params: {
        
      },
    };
  },

  methods: {
    getDataFunc(params = {}) {
      return new Promise((resolve) => {
        resolve({
          Data: [
            { TypeName: "眼影盒", TypeCode: "2", Sn: 1, Status: 1 },
            { TypeName: "粉盒", TypeCode: "3", Sn: 2, Status: 1 },
          ]
        });
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>